import { forwardRef } from 'react';
import { StyledAnchor } from './Button.styles';
import { ButtonContent } from './ButtonContent';
/**
 * An `<a>` tag based button that shares the same props and style as the button.
 * Use this button when you need to navigate to a different page.
 */
export const AnchorButton = forwardRef((props, ref) => {
    return (<StyledAnchor {...props} aria-busy={!!props.isLoading} ref={ref}>
        <ButtonContent {...props}/>
      </StyledAnchor>);
});
